export default __webpack_public_path__ + "static/media/joindiscordmobile.870cc75d.png";